import { LOYALTY_API_BASE, LOYALTY_AUTH_HEADER } from "../constants";
import { normalizeLoyaltyBrand } from "../utils/loyaltyBrand";

/**
 * Wrapper around fetch() for the Loyalty Engine API.
 *
 * Automatically injects:
 *  - Authorization: Basic <token>  (from REACT_APP_LOYALTY_API_USERNAME/PASSWORD)
 *  - X-Brand normalisé en minuscules (doit correspondre au segment brand de l’URL)
 *
 * Usage:
 *   loyaltyFetch(`${LOYALTY_API_BASE}/admin/loyalty-tiers?brand=foo`)
 *   loyaltyFetch(url, { method: "POST", body: JSON.stringify(payload), headers: { "X-Brand": brand } })
 *
 * @param {string} url       - Full URL (use LOYALTY_API_BASE + path)
 * @param {RequestInit} init - Standard fetch init options (method, headers, body, signal…)
 * @returns {Promise<Response>}
 */
export function loyaltyFetch(url, init = {}) {
    const { headers: extraHeaders = {}, ...rest } = init;
    const headers = { ...LOYALTY_AUTH_HEADER, ...extraHeaders };
    if (headers["X-Brand"]) {
        headers["X-Brand"] = normalizeLoyaltyBrand(headers["X-Brand"]);
    }
    return fetch(url, {
        ...rest,
        headers,
    });
}

export { LOYALTY_API_BASE };
